module.exports = __webpack_public_path__ + "static/media/goal-logo-color-1-rgb.84577cb6.png";